<template>
  <v-card :loading="loading">
    <v-card-title class="subtitle-2">
      Unique users per day
    </v-card-title>
    <v-card-text v-if="!show || loading" height="350" class="pa-2 caption black--text">
      <v-sheet height="350" class="d-flex justify-center align-center">
        <v-btn
          color="primary"
          :loading="loading"
          @click="show = true"
        >
          Load data
        </v-btn>
      </v-sheet>
    </v-card-text>
    <v-card-text v-else class="pa-2 caption black--text">
      <apexchart type="area" :height="350" :options="chartOptions" :series="series" />
    </v-card-text>
  </v-card>
</template>

<script>
import helper from '../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      loading: false,
      show: false,
      series: [],
      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 350,
        },
        xaxis: {
          type: 'datetime'
        },
        dataLabels: {
          enabled: false,
        }
      }
    }
  },
  watch: {
    async '$route.params' () {
      if (this.show) {
        await this.getData()
      }
    },
    async show (val) {
      if (val) {
        await this.getData()
      }
    }
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/unique-users`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.series = data
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
  .align-top {
    vertical-align: top;
  }
</style>